module.exports = __webpack_public_path__ + "static/media/15.6aa33c1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/15.jpg
// module id = 176
// module chunks = 0